module.exports = {"Type":"TableVisualization","Disabled":false,"Output":true,"Fields":[{"label":"Object JSON","type":"multiline","name":"text","serializeTo":"q"}],"Header":{"Color":"white","BackgroundColor":"#EE1010","Text":"CARD(EDIT)"}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/TableVisualization.json
// module id = 675
// module chunks = 0